// extracted by mini-css-extract-plugin
module.exports = {"line-left-arrow":"_2FlI9","line-left-arrow-fill":"_7sLAy"};